import { Actor, Engine, Vector, Color, CollisionType } from "excalibur";
import { Virus } from "../Virus";
import { ProjectileCollision } from "../../systems/CollisionGroups";
import { Resources } from "../../resources";
import { createPackedAnimation } from "../../utils/AtlasLoader";

export class PerforinZone extends Actor {
    private duration: number = 4000; // Lasts 4 seconds
    private damage: number = 5; // Damage per tick
    private tickRate: number = 200; // ms
    private tickTimer: number = 0;
    private radius: number = 60;
    private onKill: (virus: Virus) => void;

    constructor(x: number, y: number, onKill: (virus: Virus) => void) {
        super({
            pos: new Vector(x, y),
            radius: 60,
            color: Color.Transparent,
            collisionType: CollisionType.Passive,
            collisionGroup: ProjectileCollision,
        });
        this.onKill = onKill;
    }

    override onInitialize(engine: Engine): void {
        // Create animation
        const anim = createPackedAnimation(
            Resources.PerforinZoneImage,
            Resources.PerforinZoneJson,
            12
        );

        // Scale to match radius (approx)
        const scale = (this.radius * 2.5) / anim.width;
        anim.scale = new Vector(scale, scale);
        anim.opacity = 0.5; // Semi-transparent

        this.graphics.use(anim);

        // Fade out at end
        engine.clock.schedule(() => {
            this.actions.fade(0, 200).die();
        }, this.duration - 200);
    }

    override onPreUpdate(engine: Engine, delta: number): void {
        this.tickTimer += delta;
        if (this.tickTimer >= this.tickRate) {
            this.tickTimer = 0;
            this.dealDamage(engine);
        }
    }

    private dealDamage(engine: Engine): void {
        const enemies = engine.currentScene.actors.filter(a => a instanceof Virus && a.isPoolActive()) as Virus[];

        for (const enemy of enemies) {
            if (this.pos.distance(enemy.pos) <= this.radius + enemy.collider.bounds.width / 2) {
                const killed = enemy.takeDamage(this.damage);
                if (killed) {
                    this.onKill(enemy);
                }
            }
        }
    }
}
